import React, { FC, ReactNode } from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { THEME as theme } from '../../../../styles/theme';

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    width: '100%',
    height: '100%',
    padding: `${theme.layout.spacing.deka} ${theme.layout.spacing.centy}`,
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  title: {
    fontFamily: 'Roboto-Bold',
    fontSize: 14,
    fontWeight: 700,
    marginBottom: theme.layout.spacing.mili,
    textTransform: 'uppercase',
  },
  content: {
    display: 'flex',
    padding: `${theme.layout.spacing.deka} ${theme.layout.spacing.decy}`,
    flexDirection: 'column',
    backgroundColor: theme.colors.neutral.primary[5],
    borderRadius: 8,
    gap: 12,
  },
});

interface IPageSection {
  children: ReactNode;
  title: string;
  isUnstyled?: boolean;
}

const PageSection: FC<IPageSection> = ({ children, title, isUnstyled = false }) => (
  <View style={styles.container}>
    <Text style={styles.title}>{title}</Text>
    <View style={!isUnstyled ? styles.content : undefined}>{children}</View>
  </View>
);

export default PageSection;
